import React, { useState } from 'react';
import SearchInput from './components/SearchInput.jsx';
import SplitLightningOutHost from './components/SplitLightningOutHost.jsx';

/**
 * /split — multi-component POC.
 *
 * Demonstrates two top-level Lightning Out LWCs running side by side:
 *   - c-search-results on the left (list)
 *   - c-record-detail on the right (detail of the currently selected row)
 *
 * React owns: keyword (for list), selectedRecord (for detail), logout.
 */
export default function SplitView({ onLogout }) {
  const [keyword, setKeyword] = useState('');
  const [selectedRecord, setSelectedRecord] = useState(null);

  return (
    <div className="app">
      <div className="panel">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <div>
            <h1>⚡ Split View — two LWCs in one LO app</h1>
            <p className="tagline">
              Both <code>c-search-results</code> and <code>c-record-detail</code>{' '}
              are mounted as top-level Lightning Out components. Click a row on
              the left → React updates <code>record-id</code> on the right.
            </p>
          </div>
          <div className="row" style={{ gap: 8 }}>
            <a className="btn secondary" href="/">
              ← Single-root
            </a>
            <button className="btn secondary" onClick={onLogout}>
              🚪 Logout
            </button>
          </div>
        </div>

        <SearchInput value={keyword} onChange={setKeyword} />

        <div className="meta">
          Registered components:{' '}
          <code>c-search-results, c-record-detail</code>. Each gets its own iframe.
        </div>
      </div>

      <div className="panel panel--split">
        <SplitLightningOutHost
          keyword={keyword}
          selectedRecord={selectedRecord}
          onRecordSelect={setSelectedRecord}
        />
      </div>
    </div>
  );
}
